<template>
  <div>
    <CertificationsFilter :query="query" :defaultField="field" />
    <CertificationsList />
  </div>
</template>

<script>
import CertificationsList from './CertificationsList.vue';
import CertificationsFilter from './CertificationsFilter.vue';
import { mapActions as mapSearchActions, actionTypes } from 'vuex-search';

export default {
  name: 'App',
  props: {
    query: {
      type: String,
      required: false,
      default: () => '',
    },
    category: {
      type: String,
      required: false,
      default: () => null,
    },
    field: {
      type: String,
      required: false,
      default: () => null,
    },
  },
  components: {
    CertificationsList,
    CertificationsFilter,
  },
  created() {

    this.$store.commit('setFilterField', this.field);

    Promise.all([this.fetchCertifications()])
      .then(() => {
        this.$store.commit('setBeforeInitialFetch', false);
      })
      .then(() => {
        this.$store.search.registerResource('certifications', {
          index: ['title', 'meta_keywords'],
          getter: state => state.certifications,
          watch: { delay: 500 },
        });
      })
      .then(() => {
        this.searchCertification(this.query);
      });
  },
  computed: {
    fetchUrl() {
      let categoryFilter = (this.category !== null) ? `?certification_categories=${this.category}` : '';
      return `/api/v1/certifications${categoryFilter}`;
    }
  },
  methods: {
    ...mapSearchActions('certifications', {
      searchCertification: actionTypes.search,
    }),
    fetchCertifications() {
      return new Promise((resolve, reject) => {
        this.$http
          .get(this.fetchUrl)
          .then((response) => {
            this.$store.commit('setCertifications', response.data);
            this.$store.commit('setFields', response.data);
            resolve();
          })
          .catch((error) => {
            console.log(error);
            this.setError(error, 'Something went wrong');
            reject();
          });
      });
    },
  },
};
</script>
